<template>
  <span v-html="displayIcon" />
</template>

<script>
import { computed } from 'vue-demi'
import { SORT_DIRECTION } from '@/utils/sortingHelper'

const SORT_ICONS = {
  [SORT_DIRECTION.ASC]: '&#9650;',
  [SORT_DIRECTION.DESC]: '&#9660;',
}

export default {
  props: {
    iconDirection: {
      type: String,
      default: SORT_DIRECTION.ASC,
    },
  },
  setup (props) {
    return {
      displayIcon: computed(() => {
        return SORT_ICONS[props.iconDirection] || ''
      }),
    }
  },
}
</script>
